export const messageAlreadyShown = new Object();
